import React from "react";
import { MessageCircle } from "lucide-react";

const FloatingAIButton = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      aria-label="Reflecta AI"
      className="flex items-center p-3 rounded-full bg-purple-100 text-purple-600 hover:bg-purple-200 shadow-lg shadow-purple-200 transition-all"
    >
      <MessageCircle className="h-6 w-6 md:mr-2" />
      <span className="hidden md:inline">Reflecta AI</span>
    </button>
  );
};

export default FloatingAIButton;
